module.exports = __webpack_public_path__ + "static/media/delivered.4a936d68.svg";